export const FETCH_ROOMS = 'rooms/fetchRooms'
